import css from "@styled-system/css";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";
export * from "@neru/base/styles";

export const Description = styled(ReactMarkdown)(
  css({
    "& > h1, h2, h3, h4, h5, h6": {
      fontSize: "revert",
      lineHeight: "revert",
      margin: "revert",
    },
  }),
);
